<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import orders from "../stores/orders";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";


    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΕΝΤΟΛΗΣ', link: '/app/new-order', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            link: '/app/new-order',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true},
        {key: 'client_id', title: 'ΠΕΛΑΤΗΣ', sortable: true},
        {key: 'is_approved', title: 'ΕΓΚΡ.', sortable: true, class: 'hidden-xs'},
        {key: 'total_samples', title: 'ΔΕΙΓΜ.', class: 'hidden-xs'},
        {key: 'date_at', title: 'ΗΜΕΡΟΜΗΝΙΑ', sortable: true, sort_way: 'DESC', class: 'hidden-xs'},
        {key: 'sample_code_range', title: 'ΚΩΔ. ΔΕΙΓΜΑΤΩΝ', class: 'hidden-xs'},
        {key: '', title: '', hidden: !user.isAdmin()},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    const load = (loader = null) => {
        const onSuccess = result => {
            $orders.list = result.orders;
            $orders.total = result.total;
            $orders.total_samples = result.total_samples;
        }

        const onFailure = err => {
        };

        if (loader == null) {
            loader = LOADER.PAGE;
        }

        $orders.search.offset = ($orders.page - 1) * $orders.search.limit;
        if ($orders.search.client_term || $orders.search.code) {
            $orders.search.client_id = null;
        }

        R.handle(R.order.index, $orders.search, onSuccess, onFailure, loader);
    }

    const search = () => {
        $orders.page = 1;
        load();
    }

    const clearSearch = () => {
        orders.clearSearch();
        load();
    }

    const onSearchChange = () => {
        load();
    }

    const onColumnSort = ({detail}) => {
        $orders.search.sort_field = detail.key;
        $orders.search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        $orders.page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const onEdit = (order) => {
        $orders.selectedId = order.id;
        $orders.scrollY = window.scrollY;
        router.go(`/app/order/${order.id}`)();
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή εντολής", `Πρόκειται να διαγράψετε την εντολή "${item.code}".\nΘέλετε να συνεχίσετε;`, () => deleteItem(item.id));
    }

    const deleteItem = id => {
        const onSuccess = result => {
            $orders.list = $orders.list.filter(x => x.id != result);
            $orders.total--;
            Notifier.showMessage("Η εντολή διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.order.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const initialize = () => {
        // get search criteria from url parameters
        if (window.location.search) {
            let arr = window.location.search.replace("?", "").split("&");
            arr.map(item => {
                let param = item.split("=");
                if (param[0] === 'client_id') {
                    $orders.search.client_id = param[1];
                }
            });
        }

        if (!$orders.list) {
            $orders.page = 1;
            $orders.search.limit = itemsPerPage[0];

            load();
        } else if ($orders.changed) {
            // order data changed from OrderEdit component
            load(LOADER.NONE);
            $orders.changed = false;
        }

        if ($orders.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $orders.scrollY});
                $orders.scrollY = null;
            }, 50);

        }
    }

    initialize();
</script>

<PageHeader title="Εντολές" controls={ pageHeaderControls } on:reload={ load }/>

<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 col-6">
            <div class="form-group-sm form-group-md">
                <div class="form-item">
                    <div class="form-item-info top">από</div>
                    <input type="date" class="form-control" bind:value="{ $orders.search.date_from }"
                           on:change={ search }>
                </div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-3 col-6">
            <div class="form-group-sm form-group-md">
                <div class="form-item">
                    <div class="form-item-info top">έως</div>
                    <input type="date" class="form-control" bind:value="{ $orders.search.date_to }"
                           on:change={ search }>
                </div>
            </div>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-6">
            <div class="form-group-sm form-group-md">
                <input type="text" class="form-control" bind:value="{ $orders.search.code }" on:change={ search }
                       placeholder="κωδ. εντολής">
            </div>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-6">
            <div class="form-group-sm form-group-md">
                <input type="text" class="form-control" bind:value="{ $orders.search.sample_code }" on:change={ search }
                       placeholder="κωδ. δείγματος">
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6">
            <div class="form-group-sm form-group-md">
                <input type="text" class="form-control" bind:value="{ $orders.search.client_term }" on:change={ search }
                       placeholder="πελάτης">
            </div>
        </div>
        <div class="col-xl-1 col-lg-1 col-md-3 col-6">
            <button class="btn btn-default btn-block text-truncate" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-outline btn-block" on:click={ search }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ $orders.search.limit }" on:change="{ search }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    {#if $orders.list && $orders.list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Εντολές: <strong>{ $orders.total }</strong></span>
            <span class="listing-info hidden-xs">Δείγματα: <strong>{ $orders.total_samples }</strong></span>
            <span class="listing-info hidden-xs">Σελίδα: <strong>{ $orders.page }</strong></span>
        </div>
    {/if}
</div>

{#if $orders.list}
    {#if $orders.list.length}
        <table class="table table-list orders-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each $orders.list as item}
                <tr class="row-hover pointer" class:row-selected="{ $orders.selectedId === item.id }"
                    on:click={ () => onEdit(item) }>
                    <td class="code-column">
                        { item.code }
                    </td>
                    <td>
                        {#if item.client}
                            { item.client.company }
                        {/if}
                    </td>
                    <td class="button-column text-gray hidden-xs">
                        {#if item.is_approved == 1}
                            <AppIcon icon="check" strokeWidth="2" size="16"/>
                        {/if}
                    </td>
                    <td class="samples-column text-gray text-center hidden-xs">
                        { item.total_samples }
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        { formatDate(item.date_at, 'd-m-y') }
                    </td>
                    <td class="codes-column text-gray hidden-xs">
                        { item.sample_code_range }
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column pointer" title="διαγραφή εντολής"
                            on:click|preventDefault|stopPropagation="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ $orders.search.limit }" totalItems="{ $orders.total }"
                    page="{ $orders.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel panel-simple panel-pad">
            Δεν βρέθηκαν εντολές.
        </div>
    {/if}
{/if}

<style>
    .orders-list .samples-column {
        width: 80px;
    }

    .orders-list .codes-column {
        width: 150px;
    }
</style>